module.exports = __webpack_public_path__ + "static/img/help_05intro_04.ebe9fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_05intro_04.png
// module id = 723
// module chunks = 140